<template>
  <div
    class="category-tag"
    :class="
      isActive
        ? 'border-[1px] !border-primary-2 bg-primary-2  !pe-2.5 !py-2 is-active'
        : 'hover:bg-white'
    "
    @click="emit('activateCategory', slug)"
  >
    <template v-if="icon">
      <NuxtImg loading="lazy"
        v-no-right-click
        v-if="iconType == 'img'"
        :src="icon"
        class="w-6 h-6"
        :alt="title"
      />
      <component :is="icon" v-else class="icon" />
    </template>
    <span
      class="text-primary-1 md:text-heading-6 text-mobile-heading-6"
      :class="{ 'text-white ': isActive }"
    >
      {{ title }}
    </span>
    <icon-close v-if="isActive" class="text-[10px] text-white cursor-pointer" />
  </div>
</template>

<script setup lang="ts">
import type { PropType } from "vue";

type IconType = "img" | "icon";

const emit = defineEmits(["activateCategory"]);

defineProps({
  title: { type: String, required: true },
  iconType: { type: String as PropType<IconType>, default: "img" },
  icon: { type: String, required: false },
  isActive: { type: Boolean, default: false },
  slug: { type: String, required: true },
});
</script>

<style scoped>
.category-tag {
  @apply rounded-md border-[1px] border-gray-2 flex items-center w-fit cursor-pointer px-4 py-2 gap-1.5 transition-all duration-300;
  box-shadow: 0px 2px 3px 0px #0000000a;
}
</style>
